import 'Styles/templates/page.wishlist.scss';

import WishlistPage from '../vue/wishlist/wishlist-page';

WishlistPage();